enum MovableElements {
  LIST = "list",
  TASK = "task",
  MILESTONE = "milestone",
  EVENT = "event",
}

export { MovableElements };
